const withCache = (func, { invalidateTimeout } = {}) => {
    let cache = {};
    const invalidate = () => {
        cache = {};
    };
    const invalidateByKey = (key) => {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        delete cache[key];
    };
    return {
        call: (...args) => {
            const key = JSON.stringify(args);
            if (!(key in cache)) {
                if (invalidateTimeout) {
                    setTimeout(invalidateByKey, invalidateTimeout, key);
                }
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                cache[key] = func(...args);
            }
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return cache[key];
        },
        invalidate,
    };
};
export default withCache;
